// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".style_root__RssoA {\n  height: 50px;\n  background: #fff;\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box; }\n  .style_root__RssoA .style_title__1AAM5 {\n    font-size: 14px;\n    color: #333333;\n    font-weight: bold;\n    margin-bottom: 10px; }\n  .style_root__RssoA .style_headersWrap__2Cwmw {\n    display: grid;\n    grid-template-columns: 100px 1fr 1fr 0.5fr 1fr;\n    width: 100%; }\n\n.style_rootForCreator__2XNtT .style_headersWrap__2Cwmw {\n  grid-template-columns: 100px 1fr 1fr 0.5fr 1fr 2fr; }\n\n.style_avatar__22CcX,\n.style_name__1QUnz,\n.style_email__3cj1l,\n.style_access__1Rfa0,\n.style_stats__1uABb,\n.style_actions__JvPXy {\n  font-size: 12px;\n  color: #686868;\n  text-transform: capitalize; }\n", ""]);
// Exports
exports.locals = {
	"root": "style_root__RssoA",
	"title": "style_title__1AAM5",
	"headersWrap": "style_headersWrap__2Cwmw",
	"rootForCreator": "style_rootForCreator__2XNtT",
	"avatar": "style_avatar__22CcX",
	"name": "style_name__1QUnz",
	"email": "style_email__3cj1l",
	"access": "style_access__1Rfa0",
	"stats": "style_stats__1uABb",
	"actions": "style_actions__JvPXy"
};
module.exports = exports;
